import React, { Component } from "react";
// import { NavLink } from "react-router-dom";
import { withNamespaces } from "react-i18next";
import MobileSubHeader from "../../components/PageHeader/MobileSubHeader";
import BankingDetails from "./BankingDetails";
import CryptoDetails from "./CryptoDetails";
import { Accordion, TabContainer, Nav, NavItem, NavLink, TabContent, TabPane } from 'react-bootstrap'
import Skeleton from "react-loading-skeleton";

class MobileMyWallet extends Component {
    constructor(props) {
        super(props);
        this.state = {
            pageShow: "banking_details",
            showNum: false,
        };
    }

    changePageShow = (name) => {
        this.setState({
            pageShow: name,
        });
    };

    onInputChangeHandler = (event) => 
	{
        // console.log(event.target.name+' | '+event.target.value)
		if (event.target.name === 'showNum') 
        {
            this.setState({
                showNum: !this.state.showNum,
                errorMsg: [],
                formError: false,
                converted_currency: "",
                converted_amount: "",
            });
        }
        else 
        {
            this.setState({
                [event.target.name]: event.target.value,
                errorMsg: [],
                formError: false,
                converted_currency: "",
                converted_amount: ""
            });
        }

        if(event.target.name === 'amount'){
            if(this.state.memberId !== null && this.state.memberId !== "" && this.state.memberId !== undefined && event.target.value > 0){
                let data = {};
                data.member_id = this.state.memberId;
                data.amount = event.target.value;
                this.props.getCurrencyExchange(data);
            }
        }
	}

    imageImport = (r) => {
        let images = {};
        r.keys().map((item, index) => {
            return (images[item.replace("./", "")] = r(item)["default"]);
        });
        return images;
    };

    render() {
        const { t } = this.props;
        const icons = this.imageImport(require.context("../../assets/images/deposit/nav-icons", false, /\.(png|jpe?g|svg)$/));
        const walletImg = this.imageImport(require.context("../../assets/images/deposit/icons", false, /\.(png|jpe?g|svg)$/));
        const img = this.imageImport(require.context("../../assets/images/loginregister/", false, /\.(png|jpe?g|svg|webp)$/));
        let wallet = 0.0;
        if (!this.props.loading) {
            wallet = this.props.data;
        }

        return (
            <section className="pf-m-dashboard">
                <TabContainer defaultActiveKey="banking_details">
                    <div className={`filters-m-col ${this.state.filterShow ? 'show' : ''}`} >
                        <MobileSubHeader
                            className="bg-white"
                            returnPage="/"
                            header={t("wallet.my-wallet")}
                            style={{ justifyContent: "unset" }}
                        />                    
                        <div className="quota-deposit-container">
                            <div className="available-amount-content mb-3">
                            <img className="active" src={walletImg["wallet-ico.svg"]} alt="wallet-ico" />
                            <div className="amount-body w-100">
                                    <label>{t("wallet.wallet")}</label>
                                    {this.state.loading ? (
                                            <Skeleton count={1} height={20} />
                                        ) : (
                                    <div className="amount">
                                        {this.state.showNum ? 
                                            <p>
                                            {this.props.currentUser.currency}
                                            <span className="ms-2">
                                                {/* {Intl.NumberFormat("en-US", { maximumFractionDigits: 2, minimumFractionDigits: 2 }).format(this.state.data)} */}
                                                {Intl.NumberFormat("en-US", { maximumFractionDigits: 2, minimumFractionDigits: 2 }).format(wallet)}
                                            </span>
                                            </p>
                                            : 
                                                '*******'} 
                                    <img
                                        className="show-hide-btn"
                                        src={img[`${(!this.state.showNum) ? 'close-' : ''}eye.png`]}
                                        alt="hide pwd"
                                        id="showNum"
                                        name="showNum"
                                        onClick={(event) => this.onInputChangeHandler(event)}
                                    />
                                </div>
                                )}
                            </div>
                        </div>
                        </div>
                        <div className="pd-m-card-col">
                        <div className="delegate-deposit-wrap">
                            <Nav className='mobile delegate-deposit-nav' variant="pills">
                                <NavItem>
                                    <NavLink eventKey="banking_details" id="banking_details" >{t("account-details.banking-details")}</NavLink>
                                </NavItem>
                                {/* <NavItem>
                                    <NavLink eventKey="crypto_details" id="crypto_details" >{t("account-details.crypto-details")}</NavLink>
                                </NavItem> */}
                            </Nav>
                        </div>
                    <TabContent className='tab-content-container'>
                        <TabPane eventKey="banking_details">
                            <BankingDetails 
                            {...this.state}
                            {...this.props}
                            />
                        </TabPane>
                        {/* <TabPane eventKey="crypto_details">
                            <CryptoDetails 
                                {...this.state}
                                {...this.props}
                            />
                        </TabPane> */}
                    </TabContent>
                    </div>
                    </div>
                </TabContainer>
                
            </section>

        );
    }
}

export default withNamespaces("translation")(MobileMyWallet);
